export * from './lib/document-data-access.module';
export * as DocumentActions from './lib/+state/document.actions';
export * as DocumentSelectors from './lib/+state/document.selectors';
